<template>
  <v-navigation-drawer id="default-drawer" v-model="drawer" :dark="dark" :right="$vuetify.rtl" :src="drawerImage ? image : ''" :mini-variant.sync="mini" mini-variant-width="80" app width="260">
    <template v-if="drawerImage" #img="props">
      <v-img :key="image" :gradient="gradient" v-bind="props" />
    </template>

    <div class="px-2">
      <default-drawer-header />

      <v-divider class="mx-3 mb-2" />

      <default-list :items="memberItems" />
    </div>

    <template #append>
      <div class="pa-4 text-center">
        <app-btn block class="text-none mb-2" color="secondary" href="#" @click="dialogWalletCreditCharge = true">
          <v-icon left>
            mdi-wallet
          </v-icon>
          موجودی کیف پول:
          <br />
          {{ credit.toString().toPriceFormat() }} تومان

        </app-btn>
      </div>
    </template>

    <div class="pt-12" />

    <v-dialog v-model="dialogWalletCreditCharge" scrollable persistent max-width="450px">
      <v-card>
        <v-card-title>
          <div><span class="headline">شارژ کیف پول</span></div>
          <v-spacer />
          <v-btn @click="dialogWalletCreditCharge = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <WalletCreditCharge ref="walletCreditCharge" v-if="dialogWalletCreditCharge" />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { get, sync } from 'vuex-pathify'

  export default {
    name: 'DefaultDrawer',

    components: {
      DefaultDrawerHeader: () => import(
        /* webpackChunkName: "default-drawer-header" */
        './widgets/DrawerHeader'
      ),
      DefaultList: () => import(
        /* webpackChunkName: "default-list" */
        './List'
      ),
      WalletCreditCharge: () => import('@/components/forms/WalletCreditCharge'),
    },
    data() {
      return {
        dialogWalletCreditCharge: false,
      }
    },
    computed: {
      ...get('user', [
        'dark',
        'gradient',
        'image',
      ]),
      ...get('app', [
        'memberItems',
        'version',
      ]),
      ...sync('app', [
        'drawer',
        'drawerImage',
        'mini',
      ]),
      ...get('auth', [
        'getCurrentUser',
      ]),
      credit() {
        var user = this.getCurrentUser
        return user?.userData?.credit || 0
      },
    },
  }
</script>

<style lang="sass">
#default-drawer
  .v-list-item
    margin-bottom: 8px

  .v-list-item::before,
  .v-list-item::after
    display: none

  .v-list-group__header__prepend-icon,
  .v-list-item__icon
    margin-top: 12px
    margin-bottom: 12px
    margin-left: 4px

  &.v-navigation-drawer--mini-variant
    .v-list-item
      justify-content: flex-start !important
</style>
